/**
 * Full-screen loading overlay for Black Friday page
 */

export function LoadingOverlay() {
  return (
    <div className="react-css fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/50">
      <span className="react-css text-center text-lg font-bold text-white">
        Se incarca promotiile!
      </span>
    </div>
  )
}
